import rest from '@data/restWrapper';
import { startGlobalLoading, stopGlobalLoading } from '@components/loaders/globalLoading';
import {
    GroupInvoiceDetails,
    InvoiceItemsModel,
    InvoiceModelWithInvoiceItems,
    InvoicePreview,
} from '@common/modelDefinition';

interface InvoiceDataForPrintView {
    invoice: InvoiceModelWithInvoiceItems;
    refInvoice: InvoiceModelWithInvoiceItems;
}

interface posTerminalInvoiceData {
    invoice: InvoiceModelWithInvoiceItems;
    invoiceItems: InvoiceItemsModel[];
    stornoInvoices: InvoiceModelWithInvoiceItems[];
}

export async function loadInvoiceDataForPrintView(invoiceId: number): Promise<InvoiceDataForPrintView> {
    const { invoice, refInvoice } = await rest('/loadInvoiceDataForPrintView/' + invoiceId);
    return { invoice, refInvoice };
}

export async function stornoPosTerminalInvoice(
    invoiceId: number,
    reclamationReason: string,
    terminalType: string
): Promise<posTerminalInvoiceData> {
    const { invoice, invoiceItems, stornoInvoices } = await rest('/stornoPosTerminalInvoice', 'POST', {
        invoiceId,
        properties: { reclamation: 1, reclamationReason },
        terminalType,
    });
    return { invoice, invoiceItems, stornoInvoices };
}


export async function editConcludedInvoice(invoice: InvoiceModelWithInvoiceItems): Promise<InvoiceModelWithInvoiceItems> {
    const _invoice = await rest('/Invoice/' + invoice.id, 'PUT', invoice);
    return _invoice;
}


export async function getReservationInvoicePreview(reservationId: number): Promise<InvoicePreview> {
    const { invoice, invoiceItems } = await rest(`/getReservationInvoicePreview`, 'POST', { reservationId });
    return { invoice, invoiceItems };
}

export async function getReservationGroupInvoicePreview(groupUuid: string): Promise<GroupInvoiceDetails> {
    const groupInvoiceDetails: GroupInvoiceDetails = await rest(`/getReservationInvoicePreview`, 'POST', {
        groupUuid,
    });
    return groupInvoiceDetails;
}


export async function printInvoice(invoice:InvoiceModelWithInvoiceItems, country:string) {
    startGlobalLoading()
    try {
        await rest(`/printInvoice`, 'POST', {
            invoice,
            country
        });
    } catch (error) {
        console.log(error)
    }
 
    stopGlobalLoading()
}

export async function updateAdvanceTimestamp(invoice: InvoiceModelWithInvoiceItems): Promise<InvoiceModelWithInvoiceItems> {
    const _invoice = await rest('/Invoice/' + invoice.id, 'PUT', invoice);
    return _invoice;
}